import type { GatsbyBrowser } from "gatsby";
import { initAppInsights } from "./src/appInsights";

/**
 * Gatsby client entrypoint. Fires once when the app boots in the browser and
 * streams telemetry + page views to Application Insights using the
 * instrumentation key baked in at build time.
 *
 * No consent/opt-out gate is applied: this is an internal Wisr incubator site
 * (Pulumi appTypes: Internal, owner Platforms) with no public end users, and the
 * repo has no consent framework to hook into. Application Insights collects
 * first-party operational telemetry only. Revisit if this site is ever exposed
 * to external users, at which point a consent guard must precede init.
 */
export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  initAppInsights();
};
